import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,
  
  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    descripcionglobal:'',
    tiposdocumentos:[],
    tipodocumento:[]
    
  },
  mutations: {

    LoadProductos(state,buscar) {
      //let aux = [];
      state.tipodocumento = state.tiposdocumentos;

      let aux = state.tiposdocumentos.filter((x) => x["tipodocumento"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.tipodocumento = state.tiposdocumentos;
      } else {
        state.tipodocumento = aux;
     
      }
    },
   
    async cargardatosdocumentos(state){
      
      state.tiposdocumentos = []
      var token = store.state.numero;
      await axios
      .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tiposdocumentos", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        state.tiposdocumentos = response.data.data;
   
      });
      state.tipodocumento = state.tiposdocumentos
    },
    cambio(state,descripcion){
     state.descripcionmodal =descripcion
  
    },
    agregartable(state)  {
    
      
      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        tipodocumento: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal
      
 
      
      var datosfalso = state.idmodal;
     
      if (this.banderamodal === true) {
        
        
        axios
        
        .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tiposdocumentos", datos, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          this.token = tokenn;
          
          
        })
        
        .catch((e) => {
          console.log(e);
        });
      } else {
        
        axios
        
        .post(
          "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tiposdocumentos/UpdateReg/" +
          datosfalso,
          datos,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
          
          })
          
          .catch((e) => {
            console.log(e);
          });
        }
        
      },
      
      
      datosmodal(state, api) {
      
        state.idmodal = api.idtipodocumento,
        state.descripcionmodal = api.tipodocumento
        
    
        
      },
      
      
      
      eliminar(state, api) {
        var token = store.state.numero
        let eliminar = api;
   
        axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tiposdocumentos/DeleteReg/" + eliminar,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        
        
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;
       
          //this.bandera = true;
        })
        
        .catch((e) => {
          console.log(e);
        });
        
        
        
      },
      
      
      
    },
    actions: {
      
    },
    getters: {
      
      
    },
    
    
    



}